<template lang="pug">
#historico-recebimentos
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.titulo")',
        icon='mdi mdi-history',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        main
            h3.historico-recebimentos__subtitulo {{ $t('mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.subtitulo') }}

            el-card(
                :body-style='{ padding: "0px" }',
                shadow='never'
            )
                el-table(
                    :data='lotesPaginados',
                    v-loading='carregando',
                    :row-key='chaveLinha',
                    style='width: 100%',
                    :empty-text='$t("mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.vazio")'
                )
                    el-table-column(type='expand')
                        template(slot-scope='scope')
                            TabelaRegistrosLote(:registros='scope.row.registros')

                    el-table-column(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.arquivo")',
                        min-width='260'
                    )
                        template(slot-scope='scope')
                            .historico-recebimentos__arquivo
                                i.mdi.mdi-file-document-outline
                                span {{ scope.row.nomeArquivo || $t('mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.semArquivo') }}

                    el-table-column(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.dataHora")',
                        width='180'
                    )
                        template(slot-scope='scope') {{ scope.row.dataCadastro }}

                    el-table-column(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.status")',
                        width='170'
                    )
                        template(slot-scope='scope')
                            el-tag(
                                v-if='scope.row.status',
                                :type='corStatusLote(scope.row.status)',
                                size='small',
                                effect='light'
                            ) {{ rotuloStatusLote(scope.row.status) }}
                            span(v-else) -

                    el-table-column(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.totalRegistros")',
                        width='120',
                        align='center'
                    )
                        template(slot-scope='scope') {{ scope.row.totalRegistros }}

                    el-table-column(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.resultado")',
                        min-width='200'
                    )
                        template(slot-scope='scope')
                            .historico-recebimentos__resultado
                                el-tag(
                                    v-if='scope.row.totalConcluidos != null',
                                    type='success',
                                    size='mini',
                                    effect='plain'
                                ) {{ scope.row.totalConcluidos }} {{ $t('mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.concluidos') }}
                                el-tag(
                                    v-if='scope.row.totalDiscrepancias != null',
                                    type='danger',
                                    size='mini',
                                    effect='plain'
                                ) {{ scope.row.totalDiscrepancias }} {{ $t('mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.discrepancias') }}

                .historico-recebimentos__paginador
                    b {{ paginacao.total }} {{ $t('mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.lotes') }}
                    el-pagination(
                        small,
                        background,
                        layout='prev, pager, next',
                        :page-size='paginacao.tamanho',
                        :current-page.sync='paginaAtual',
                        :total='paginacao.total',
                        @current-change='mudarPagina'
                    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import TabelaRegistrosLote from '@/components/contratosOriginacao/TabelaRegistrosLote.vue';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';

const CORES_STATUS_LOTE = {
    CONCLUIDO: 'success',
    ERRO_PROCESSAR: 'danger',
    EM_PROCESSAMENTO: 'warning',
    AGUARDANDO: 'info',
    AGUARDANDO_VINCULO: 'info'
};

const TAMANHO_BUSCA_PARA_AGRUPAMENTO = 500;
const TAMANHO_PAGINA_LOTES = 5;

export default {
    name: 'EmpresaHistoricoRecebimentos',

    components: {
        BaseHeader,
        TabelaRegistrosLote
    },

    data() {
        return {
            lotes: [],
            carregando: false,
            paginaAtual: 1,
            paginacao: {
                pagina: 0,
                tamanho: TAMANHO_PAGINA_LOTES,
                total: 0
            }
        };
    },

    computed: {
        lotesPaginados() {
            const inicio = this.paginacao.pagina * this.paginacao.tamanho;
            return this.lotes.slice(inicio, inicio + this.paginacao.tamanho);
        }
    },

    mounted() {
        this.buscarHistorico();
    },

    methods: {
        corStatusLote(status) {
            return CORES_STATUS_LOTE[status] || 'info';
        },

        rotuloStatusLote(status) {
            const chave = `mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.statusLote.${status}`;
            const rotulo = this.$t(chave);

            return rotulo === chave ? status : rotulo;
        },

        chaveLinha(lote) {
            return `lote-${lote.idLote}`;
        },

        async buscarHistorico() {
            this.carregando = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.buscarHistoricoRecebimentos(
                        0,
                        TAMANHO_BUSCA_PARA_AGRUPAMENTO
                    );

                const registros = data.content || data || [];
                this.lotes = this.agruparRegistrosPorLote(registros);
                this.paginacao.total = this.lotes.length;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.erroBuscarLotes'
                    )
                );
            } finally {
                this.carregando = false;
            }
        },

        agruparRegistrosPorLote(registros) {
            const grupos = new Map();

            registros.forEach(registro => {
                const chave = `lote-${registro.idLote}`;

                if (!grupos.has(chave)) {
                    grupos.set(chave, []);
                }
                grupos.get(chave).push(registro);
            });

            return Array.from(grupos.values()).map(itens => {
                const primeiro = itens[0];

                return {
                    idLote: primeiro.idLote,
                    nomeArquivo: primeiro.nomeArquivo,
                    dataCadastro: primeiro.dataCadastro,
                    status: primeiro.loteStatus,
                    registros: itens,
                    totalRegistros: itens.length,
                    totalConcluidos: itens.filter(
                        i => i.status === 'CONCLUIDO'
                    ).length,
                    totalDiscrepancias: itens.filter(
                        i => i.status === 'DISCREPANCIA'
                    ).length
                };
            });
        },

        mudarPagina(pagina) {
            this.paginacao.pagina = pagina - 1;
        }
    }
};
</script>

<style lang="scss">
#historico-recebimentos {
    main {
        margin: 16px 0;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .el-card {
        border-radius: 10px;
    }

    .historico-recebimentos__subtitulo {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }

    .historico-recebimentos__arquivo {
        display: flex;
        align-items: center;
        gap: 8px;

        i {
            color: var(--primary);
            font-size: 18px;
        }
    }

    .historico-recebimentos__resultado {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    .historico-recebimentos__paginador {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 16px;

        b {
            color: var(--primary);
            font-size: 12px;
        }
    }
}
</style>
